import {clientPostWrapper} from "../api/Api";
import {GET_ALL_MLINK_CAMPAIGNS, GET_GENERATED_LINK} from "../common/constants/routes";


export const getAllCampaigns = () => {
    return clientPostWrapper(GET_ALL_MLINK_CAMPAIGNS)
}


export const getGeneratedLinkFromAPI = (payload) => {
    return clientPostWrapper(GET_GENERATED_LINK, payload)
}

